import { AppBar as MuiAppBar, Toolbar, Typography, Box, Button } from '@mui/material';
import { ArrowBack, Reddit as RedditIcon } from '@mui/icons-material';

interface HeaderBarProps {
  canonicalSubredditName: string;
  username: string;
  onBack: () => void;
  onLogout: () => void;
}

export default function HeaderBar({
  canonicalSubredditName,
  username,
  onBack,
  onLogout,
}: HeaderBarProps) {
  return (
    <MuiAppBar position="static" color="primary">
      <Toolbar>
        <Button
          color="inherit"
          startIcon={<ArrowBack />}
          onClick={onBack}
          sx={{ mr: 2 }}
        >
          Back to /r/{canonicalSubredditName}
        </Button>
        <RedditIcon sx={{ mr: 2 }} />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          /r/{canonicalSubredditName} Flair Admin
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2">{username}</Typography>
          <Button color="inherit" onClick={onLogout}>
            Logout
          </Button>
        </Box>
      </Toolbar>
    </MuiAppBar>
  );
}
